import { render, staticRenderFns } from "./ReviewsByField.vue?vue&type=template&id=c5e2dc98&scoped=true&"
import script from "./ReviewsByField.vue?vue&type=script&lang=js&"
export * from "./ReviewsByField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e2dc98",
  null
  
)

export default component.exports